/** @format */
import React, { FunctionComponent, useContext, useState } from 'react';

import {
    ApplicationContext,
    ModalSize,
} from '@toucan/client/global/application';

import { CarouselBase } from './base';
import { CarouselModal } from './modal';
import { CarouselProps, CarouselVariant } from './types';

export const DEFAULT_TEST_ID = 'carousel';

export { CarouselModal, CarouselVariant };

export const Carousel: FunctionComponent<CarouselProps> = ({
    initialPage,
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    ...otherProps
}) => {
    const { setModalContent, setModalVisible, setModalSize } =
        useContext(ApplicationContext);

    const [activeIndex, setActiveIndex] = useState<number>(initialPage ?? 0);

    const handleActiveIndexChange = (index: number) => {
        setActiveIndex(index);
    };

    const handleItemClick = (index: number) => {
        setActiveIndex(index);
        setModalSize(ModalSize.FULLSCREEN);
        setModalContent(
            <CarouselModal
                items={otherProps.items}
                paginationItems={otherProps.paginationItems}
                initialPage={index}
                onActiveIndexChange={handleActiveIndexChange}
                note={otherProps.note}
            />
        );
        setModalVisible(true);
    };

    return (
        <CarouselBase
            {...otherProps}
            data-testid={dataTestId}
            initialPage={activeIndex}
            onFocussedItemClick={handleItemClick}
        />
    );
};
